import { DocumentsOfSingleObjectView } from "src/components/views/documents/objectDocuments/DocumentsOfSingleObjectView.tsx";
import { Permissions } from "src/api/generated/iam/permissions.ts";
import { useHasPermission } from "src/components/views/erp/common/userPermissions.ts";

export interface SalesLeadDocumentsViewProps {
	salesLeadId: number;
	hidePreview?: boolean;
}

export const SalesLeadDocumentsView = ({ salesLeadId, hidePreview }: SalesLeadDocumentsViewProps) => {
	const hasPermission = useHasPermission();
	const editable = hasPermission(Permissions.Sales.SalesLeads.MANAGE);

	return (
		<DocumentsOfSingleObjectView
			objectRef={{
				objectType: "SALES_LEAD",
				objectId: salesLeadId,
			}}
			editable={editable}
			hidePreview={hidePreview}
		/>
	);
};
